
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Popup, Field, Toast } from 'vant';

Vue.use(Popup).use(Field).use(Toast);

@Component
export default class LotteryForm extends Vue {
  @Prop() show!: boolean;

  visible = false;
  formData = {
    name: '',
    phone: '',
    email: '',
    student_num: '',
    school: '',
    department: '',
    klingai: ''
  };

  @Watch('show', { immediate: true })
  onShowChange(val: boolean) {
    this.visible = val;
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    if (!val) {
      this.$emit('close');
    }
  }

  handleCancel() {
    this.visible = false;
    // 重置表单
    this.formData = {
      name: '',
      phone: '',
      email: '',
      student_num: '',
      school: '',
      department: '',
      klingai: ''
    };
  }

  handleConfirm() {
    // 表单验证
    if (!this.formData.name) {
      Toast.fail('请输入姓名');
      return;
    }
    if (!/^[\u4e00-\u9fa5]+$/.test(this.formData.name)) {
      Toast.fail('姓名必须为汉字');
      return;
    }
    if (!this.formData.phone) {
      Toast.fail('请输入电话');
      return;
    }
    if (!/^1[3-9]\d{9}$/.test(this.formData.phone)) {
      Toast.fail('请输入正确的手机号');
      return;
    }
    if (!this.formData.email) {
      Toast.fail('请输入邮箱');
      return;
    }
    if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.formData.email)) {
      Toast.fail('请输入正确的邮箱');
      return;
    }
    if (!this.formData.student_num) {
      Toast.fail('请输入学生证号');
      return;
    }
    if (!this.formData.school) {
      Toast.fail('请输入在读院校');
      return;
    }
    if (!this.formData.department) {
      Toast.fail('请输入所在院系');
      return;
    }
    if (!this.formData.klingai) {
      Toast.fail('请输入可灵账户');
      return;
    }

    // 触发提交事件
    this.$emit('submit', this.formData);
    // 重置表单并关闭
    this.handleCancel();
  }
}
